// material-ui
import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/material';

//third-party
import { DropzoneOptions } from 'react-dropzone';

// ==============================|| TYPES - DROPZONE  ||============================== //

export enum DropzoneType {
    default = 'DEFAULT',
    standard = 'STANDARD',
}

export interface CustomFile extends File {
    path?: string;
    preview?: string;
    lastModifiedDate?: Date;
}

export interface UploadProps extends DropzoneOptions {
    error?: boolean;
    file: CustomFile | null;
    sx?: SxProps<Theme>;
    type?: DropzoneType;
    name: string;
    setFieldValue: (field: string, value: any) => void;
    setFieldTouched: (field: string, isTouched?: boolean, shouldValidate?: boolean) => void;
    onUpload?: VoidFunction;
    onRemove?: (file: File | string) => void;
}

export interface FilePreviewProps {
    showList?: boolean;
    type?: DropzoneType;
    files: (File | string)[];
    onRemove?: (file: File | string) => void;
}
